// 设备监控路由

const TerminalControl = [
    // 设备监控列表
    {
        path: '/terminalcontrollist',
        component: resolve => require(['@/views/TerminalControl/TerminalControlList/TerminalControlList'], resolve),
        name: 'terminalcontrollist',
        meta: { title: '监控列表', breadcrumb: [{ menu: 'terminalcontrollist' }], role: 'collector' },
    },
    // 添加设备监控
    {
        path: '/terminalcontrollist/terminalcontrolset/:OID',
        component: resolve => require(['@/views/TerminalControl/TerminalControlSet/TerminalControlSet'], resolve),
        name: 'terminalcontrolset',
        meta: { title: '监控设置',  breadcrumb: [{ menu: 'terminalcontrollist', path: '/terminalcontrollist' }, { menu: 'terminalcontrolset' }], role: 'collector' }
    },
    {
        path: '/devicefault',
        component: resolve => require(['@/views/TerminalControl/DeviceFault/DeviceFault'], resolve),
        name: 'devicefault',
        meta: { title: '故障列表', breadcrumb: [{ menu: 'devicefault' }], role: 'collector' },
    },
];

export default TerminalControl